import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomHeaderComponent } from '../dynamic-calendar/custom-header/custom-header.component';
import { FormBuilder } from '@angular/forms';

@Component({
	selector: 'app-dynamic-range-calendar',
	templateUrl: './dynamic-range-calendar.component.html',
	styleUrls: ['./dynamic-range-calendar.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class DynamicRangeCalendarComponent {
	@Input() minDate: Date | null = null;
	@Input() maxDate: Date | null = null;
	@Input() minDateEnd: Date | null = null;
	@Input() label = '';

	customHeader = CustomHeaderComponent;

	range = this.formBuilder.group({
		start: [''],
		end: ['']
	});

	constructor(private formBuilder: FormBuilder) {}
}
